import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { GlassPanel } from './ui/GlassPanel';

export type MetricCardTone = 'green' | 'red' | 'blue' | 'orange';

const toneStyles: Record<
  MetricCardTone,
  { color: string; bg: string; shadow: string | undefined }
> = {
  green: { color: 'signal.good', bg: 'signal.good/10', shadow: 'glowGood' },
  red: { color: 'signal.bad', bg: 'signal.bad/10', shadow: 'glowBad' },
  blue: { color: 'signal.blue', bg: 'signal.blue/10', shadow: 'glowBlue' },
  orange: { color: 'signal.warn', bg: 'signal.warn/10', shadow: undefined },
};

export function MetricCard({
  icon,
  title,
  value,
  detail,
  tone,
}: {
  icon: ReactNode;
  title: string;
  value: string;
  detail: string;
  tone: MetricCardTone;
}) {
  const t = toneStyles[tone];
  return (
    <GlassPanel as="article">
      <Flex align="center" gap="4" p="4">
        <Box
          display="grid"
          placeItems="center"
          h="14"
          w="14"
          borderRadius="oqPanel"
          color={t.color}
          bg={t.bg}
          {...(t.shadow ? { boxShadow: t.shadow } : {})}
        >
          {icon}
        </Box>
        <Stack gap="0">
          <Text fontSize="sm" color="text.muted">
            {title}
          </Text>
          <Text mt="1" fontSize="2xl" fontWeight="semibold" letterSpacing="tight" color="text.primary">
            {value}
          </Text>
          <Text mt="1" fontSize="sm" color="text.muted">
            {detail}
          </Text>
        </Stack>
      </Flex>
    </GlassPanel>
  );
}